// The international (/elchemy-tech/intl) route renders the same revamped
// "Our Technology" page as the US route. Non-US visitors are redirected here by
// LocationWrapper; keeping a single source of truth means both see the new design.
export { default, getServerSideProps } from "../index";
